// En yavaş / en sık API tabloları (Genel Bakış ve API ekranında ortak)
import { fmtMs, fmtNum, fmtPct } from './perfFormat';

export const ApiTable = ({ rows, testId, showAll = false }) => (
  <div className="overflow-x-auto" data-testid={testId}>
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-500">
          <th className="py-2 pr-3 font-medium">API</th><th className="px-2 font-medium text-right">İstek</th>
          <th className="px-2 font-medium text-right">P50</th><th className="px-2 font-medium text-right">P95</th><th className="px-2 font-medium text-right">P99</th>
          {showAll && <th className="px-2 font-medium text-right">En yüksek</th>}
          <th className="px-2 font-medium text-right">Hata (5xx)</th>{showAll && <th className="px-2 font-medium text-right">4xx</th>}
          <th className="px-2 font-medium text-right">Ort. boyut</th>{showAll && <th className="pl-2 font-medium text-right">2 sn üzeri</th>}
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={10} className="py-6 text-center text-slate-400">Bu aralıkta ölçüm yok</td></tr>}
        {rows.map((r, i) => (
          <tr key={r.api} className="border-b border-slate-100 last:border-0 hover:bg-slate-50" data-testid={`${testId}-row-${i}`}>
            <td className="max-w-[420px] truncate py-2 pr-3 font-mono text-xs text-slate-800" title={r.api}>{r.api}
              {r.few_samples && <span className="ml-2 rounded bg-amber-100 px-1.5 py-0.5 font-sans text-[10px] font-medium text-amber-800">az örnek</span>}</td>
            <td className="px-2 text-right tabular-nums">{fmtNum(r.count)}</td>
            <td className="px-2 text-right tabular-nums">{fmtMs(r.p50)}</td>
            <td className={`px-2 text-right tabular-nums ${r.p95 >= 2000 ? 'font-semibold text-rose-600' : ''}`}>{fmtMs(r.p95)}</td>
            <td className="px-2 text-right tabular-nums">{fmtMs(r.p99)}</td>
            {showAll && <td className="px-2 text-right tabular-nums">{fmtMs(r.max)}</td>}
            <td className={`px-2 text-right tabular-nums ${r.err5xx ? 'text-rose-600' : ''}`}>{fmtNum(r.err5xx)} <span className="text-xs text-slate-400">({fmtPct(r.err_rate)})</span></td>
            {showAll && <td className="px-2 text-right tabular-nums">{fmtNum(r.err4xx)}</td>}
            <td className="px-2 text-right tabular-nums">{r.avg_kb == null ? '—' : `${r.avg_kb.toLocaleString('tr-TR')} KB`}</td>
            {showAll && <td className="pl-2 text-right tabular-nums">{fmtNum(r.slow)}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
